<template>

  <loader v-if="!listings.data" />
  <div v-else-if="listings.data.length === 0">
    No active job listings.
  </div>
  <div v-else>
    <table>
      <thead>
        <th>ID</th>
        <th v-if="isAdmin" class="text-left">Office</th>
        <th class="text-left">Title</th>
        <th>Created</th>
        <th>Applicants</th>
        <th>Actions</th>
      </thead>
      <tbody>
        <tr v-for="listing in listings.data" :key="listing.id">
          <td class="text-center">
            #{{ listing.id }}
          </td>
          <td v-if="isAdmin">
            {{ listing.office ? listing.office.name : "-" }}
          </td>
          <td>
            <div class="flex justify-between items-center">
              {{ listing.job_title }}
              <div class="flex items-center">
                <span v-if="moment(listing.expires_at).isBefore()" class="text-xs">
                  Expired {{ moment(listing.expires_at).fromNow() }}
                </span>
                <span v-else-if="!listing.approved" class="text-xs bg-secondary text-white py-1 px-2 rounded-full">
                  Awaiting Approval
                </span>
              </div>
            </div>
          </td>
          <td class="text-center">
            {{ moment(listing.created_at).fromNow() }}
          </td>
          <td class="text-center">
            {{ listing.applications_count }}
          </td>
          <td class="text-center">
            <button
              type="button"
              class="mx-2"
              :class="{ 'text-tertiary cursor-pointer': listing.applications_count > 0, 'cursor-default': listing.applications_count === 0 }"
              :disabled="listing.applications_count === 0"
              @click="$emit('select-applications', listing)"
              title="View Applications"
            >
              <i class="fas fa-users fa-fw"></i>
            </button>
            <button type="button" class="text-tertiary mx-2" title="Edit" @click="$emit('select-listing', listing)">
              <i class="far fa-edit fa-fw"></i>
            </button>
            <button
              type="button"
              class="text-tertiary mx-2"
              :class="{ 'opacity-50': listing.deleting }"
              title="Delete"
              @click="openModal(listing)"
            >
              <i class="far fa-trash-alt fa-fw"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <paginator :data="listings" @change="$emit('page-changed', $event)"/>
    <modal
      v-if="leaveModal"
      :scrollY="false"
      @dismissed="leaveModal = false"
      @leave="leaveModal = false"
      :showCloseBtn="true"
    >
      <div class="flex h-full flex-col items-center justify-center">
        <div class="p-2 mb-4">
          <p class="text-center">Are you sure you wish to delete?</p>
        </div>
        <div class="flex items-center">
          <button  @click="destroy(selectedListing)" class="bg-tertiary border border-tertiary text-white rounded px-6 py-3 text-sm font-medium align-bottom m-2">
            Yes
          </button>
          <button @click="leaveModal = false" class="bg-white border border-tertiary text-tertiary rounded px-4 py-3 text-sm font-medium align-bottom m-2">
            No, go back.
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { v2Api } from '@/http'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'listings',

  props: [ 'listings' ],

  computed: {
    ...mapState([ 'profile' ]),

    isAdmin () {
      return this.profile.type <= 2
    }
  },
  data () {
    return {
      leaveModal: false,
      selectedListing: null
    }
  },
  methods: {
    ...mapActions([ 'displayToastNotification' ]),

    moment: moment,
    openModal (listing) {
      this.leaveModal = true
      this.selectedListing = listing
    },
    destroy (listing) {
      this.$set(listing, 'deleting', true)

      v2Api
        .delete(`/recruitment-listings/${listing.id}`)
        .then(() => {
          this.listings.data.splice(this.listings.data.indexOf(listing), 1)
          this.leaveModal = false
          this.selectedListing = null
        })
        .catch(() => {
          listing.deleting = false
          this.displayToastNotification({
            type: 'warning',
            icon: 'fa-exclamation-triangle',
            title: 'Unable to delete listing',
            info: `We've been unable to delete ${listing.job_title} at this time.`
          })
        })
    }
  }
}
</script>

<style lang="sass" scoped>
table
  @apply table-auto w-full
  thead
    @apply border-b uppercase text-xs
    th
      @apply pb-2 font-semibold
  tbody
    @apply text-sm capitalize
    tr
      @apply border-b
      td
        @apply py-4 align-middle
</style>
